import { initSelect } from "../../components/basics/select_dropdown.js";
import { initPlasticRedemption } from "../generic/plastic_redemption";
// import {initBitcoinRedemption} from '../generic/bitcoin_redemption';
import I18n from "../../../translations/i18n";

export function initRedemptions() {
  formatCurrencyAsUserTypes();
  redemptionErrorMessageListener();
  radioButtonSelectedListener();
  initRedeemSelects();
  userSelectedNewEmailListener();
  userAgreedToTermsListener();
  charityRedemptionFormErrorMessageListener();
  setStatesForRedemptionOption();
  confirmRedemptionListener();
  receiveBitcoinListener();
  initPlasticRedemption();
  // initBitcoinRedemption();
  cashForwardAgreeListener();
}

export function initRedeemSelects() {
  $(".redeem-info-container .select").each(function (index) {
    initSelect($(this));
  });
}

export function receiveBitcoinListener() {
  $(".redeem-info-container .bitcoin-redemption .bitcoin-delivery-select").on(
    "selectActiveClassChanged",
    function () {
      var deliveryType = $(this).find("input#redemption_delivery_type").val();
      updateBitcoinOption(deliveryType);
    }
  );
}

export function updateBitcoinOption(deliveryType) {
  if (deliveryType == "bitcoin_delivery_wallet") {
    $(".bitcoin-redemption .wallet-delivery").show();
    $(".bitcoin-redemption .email-delivery").hide();
    $(".bitcoin-redemption .delivery-type-confirmation").text("Wallet");
    $("#redemption_delivery_type").val("wallet");
  } else if ((deliveryType = "bitcoin_delivery_email")) {
    $(".bitcoin-redemption .wallet-delivery").hide();
    $(".bitcoin-redemption .email-delivery").show();
    $(".bitcoin-redemption .delivery-type-confirmation").text("Email");
    $("#redemption_delivery_type").val("email");
  }
}

export function showConfirmationPopup() {
  $(".confirm-redemption-popup-container:first").removeClass("hidden");
}

export function confirmRedemptionListener() {
  $(document).on("click", ".confirm-redemption-btn", function () {
    if ($(".error.active").length == 0) {
      var form = $(this).closest("form");
      if ($(this).hasClass("plastic")) {
        // Plastic Redemption - show real life address
        var firstName = form.find('input[name="redemption[first_name]"]').val();
        var lastName = form.find('input[name="redemption[last_name]"]').val();
        var addressOne = form
          .find('input[name="redemption[address_line_one]"]')
          .val();
        var addressTwo = form
          .find('input[name="redemption[address_line_two]"]')
          .val();
        var zip = form.find('input[name="redemption[postal_code]"]').val();
        var city = form.find('input[name="redemption[city]"]').val();
        var state = form.find('select[name="redemption[state]"]').val();
        var country = form.find("#choose-country .item-text").html();
        // var country = form.find('input[name="redemption[country]"]').val();

        $(".confirm-redemption-popup .name").html(firstName + " " + lastName);
        $(".confirm-redemption-popup .address-1").html(addressOne);
        $(".confirm-redemption-popup .address-2").html(addressTwo);
        $(".confirm-redemption-popup .zip").html(zip);
        $(".confirm-redemption-popup .city").html(city);
        $(".confirm-redemption-popup .state").html(state);
        $(".confirm-redemption-popup .country").html(country);
      } else if ($(this).hasClass("global-giving")) {
        var firstName = $(
          '.global-giving-redeem-container input[name="redemption[first_name]"]'
        ).val();
        var lastName = $(
          '.global-giving-redeem-container input[name="redemption[last_name]"]'
        ).val();
        var amount = $(
          ".global-giving-redeem-container #redemption_amount"
        ).val();
        var emailAddress = $(
          '.global-giving-redeem-container input[name="redemption[receiver_email]"]'
        ).val();

        $(".confirm-redemption-popup #js-address").html(emailAddress);
        $(".confirm-redemption-popup #js-name").html(
          firstName + " " + lastName
        );
        $(".confirm-redemption-popup #js-amount").html(amount);
      } else if ($(this).hasClass("bitcoin")) {
        var deliveryType = $(
          ".bitcoin-delivery-select #redemption_delivery_type"
        ).val();
        var deliveryAddress = $("#redemption_receiver_email").val();
        if (deliveryType == "bitcoin_delivery_wallet") {
          deliveryAddress = $("#redemption_wallet_address").val();
        }
        $(".confirm-redemption-popup #js-chosen-delivery-address").html(
          deliveryAddress
        );
      } else if ($(this).hasClass("voucher")) {
        $(this)
          .parent("form")
          .find(".confirm-redemption-popup-container")
          .removeClass("hidden");
        return;
      } else {
        // Virtual Redemption - show email address
        var emailAddress = $(".email-select h3").text();
        $(".confirm-redemption-popup #js-address").html(emailAddress);
      }
      showConfirmationPopup();
    }
  });
}

export function formatCurrencyAsUserTypes() {}

// Only validation for virtual redemption
export function userAgreedToTermsListener() {
  $(".virtual-redemption").on(
    "click",
    ".checkbox-agree, .confirm-label",
    function () {
      setTimeout(function () {
        if ($("#redemption_terms")[0].checked) {
          $(".confirm-redemption-btn")
            .addClass("primary-btn")
            .removeClass("disabled-btn");
        } else {
          $(".confirm-redemption-btn")
            .removeClass("primary-btn")
            .addClass("disabled-btn");
        }

        $(".checkbox-error").hide();
      }, 10);
    }
  );

  $(".confirm-redemption").on("click", function () {
    if ($("#redemption_terms")[0].checked == false) {
      $(".checkbox-error").show();
    }
  });
}

export function charityRedemptionFormcheckAllValid() {
  // Check to see if everything is filled in
  var numberValid = 0;
  var requiredFields = $(".charity-redemption-info-form input:required");
  requiredFields.each(function (index, element) {
    var redemption = $(element)[0];
    if (redemption.validity.valid) {
      numberValid += 1;
    }
  });

  if (numberValid == $(".charity-redemption-info-form input:required").length) {
    $(".charity-redemption .confirm-redemption-btn")
      .addClass("primary-btn")
      .removeClass("disabled-btn");
  } else {
    $(".charity-redemption .confirm-redemption-btn")
      .removeClass("primary-btn")
      .addClass("disabled-btn");
  }
}

export function showCharityRedemptionError(
  redemption,
  redemptionErrorText,
  redemptionError
) {
  var currencySymbol = redemption.getAttribute("data-currency-symbol");
  var minAmount = redemption.getAttribute("min");
  if (
    redemption.validity.rangeOverflow &&
    parseFloat(redemption.max) <=
      parseFloat(redemption.getAttribute("absolute_max"))
  ) {
    redemptionErrorText.textContent = I18n.t(
      "views.dashboards.cash_for_a_cause_page.form.errors_1.text_3"
    );
  } else if (redemption.validity.rangeUnderflow) {
    redemptionErrorText.textContent = I18n.t(
      "views.dashboards.cash_for_a_cause_page.form.errors_1.text_2",
      { min_amount: minAmount }
    );
  } else if (redemption.validity.valueMissing) {
    redemptionErrorText.textContent = I18n.t(
      "views.dashboards.cash_for_a_cause_page.form.errors_1.text_1"
    );
  } else if (redemption.validity.typeMismatch) {
    redemptionErrorText.textContent = I18n.t(
      "views.dashboards.cash_for_a_cause_page.form.errors_4.text_1"
    );
  }

  // Set the styling appropriately
  redemptionError.className = "error active";
  charityRedemptionFormcheckAllValid();
}

export function charityRedemptionFormErrorMessageListener() {
  var requiredFields = $(".charity-redemption-info-form input:required");

  requiredFields.each(function (index, element) {
    var redemption = $(element)[0];
    var redemptionError = $(element)
      .closest(".error-wrapper")
      .find("span.error")[0];
    var redemptionErrorText = $(element)
      .closest(".error-wrapper")
      .find("span.error .error-text")[0];

    redemption.addEventListener("change", function (event) {
      redemptionErrorText.innerHTML = ""; // Reset the content of the message
      if (!redemption.validity.valid) {
        $(".charity-redemption .confirm-redemption-btn")
          .addClass("disabled-btn")
          .removeClass("primary-btn");
        showCharityRedemptionError(
          redemption,
          redemptionErrorText,
          redemptionError
        );
        event.preventDefault();
      } else {
        charityRedemptionFormcheckAllValid();
        redemptionError.className = "error";
      }
    });
  });
}

export function userSelectedNewEmailListener() {
  $(".select")
    .off("changedSelectVal")
    .on("changedSelectVal", function () {
      var selectedEmail = $("#choose-email .item-text").text().trim();
      $("#redemption_receiver_email").val(selectedEmail);
    });
}

export function setStatesForRedemptionOption() {
  var redemptionForms = $(".redemption-form");
  var redemptionType = $(".redemption-form .redemption-type");

  redemptionForms.each(function (index, element) {
    var redemptionInput = $(element).find(".redemption-input-wrapper input");
    var redemptionRadioButtons = $(element).find(
      ".redemption-radio-group input"
    );

    redemptionInput.on("input", function () {
      // Starbucks allow only one redemption type to be selected
      if (redemptionInput.length && redemptionRadioButtons.length) {
        redemptionRadioButtons.each(function (index, element) {
          $(element)[0].checked = false;
          redemptionType.val("virtual");
        });
      }
    });

    redemptionRadioButtons.on("input", function () {
      // Starbucks allow only one redemption type to be selected
      if (redemptionInput.length && redemptionRadioButtons.length) {
        redemptionInput.val("");
        redemptionType.val("plastic");
      }

      // Amazon, Starbucks - set redemption type
      if ($(this).closest(".card-type-group").hasClass("plastic")) {
        redemptionType.val("plastic");
      } else if ($(this).closest(".card-type-group").hasClass("virtual")) {
        redemptionType.val("virtual");
      }
    });
  });
}

export function radioButtonSelectedListener() {
  var redemptionRadioButtons = $(
    ".redemption-form .redemption-radio-group input"
  );
  redemptionRadioButtons.on("click", function () {
    console.log("clicked radio button");
    $(this)
      .closest("form")
      .find(".submit-btn")
      .addClass("primary-btn")
      .removeClass("disabled-btn");
  });
}

export function redemptionErrorMessageListener() {
  var redemptionForms = $(".redemption-form");

  redemptionForms.each(function (index, element) {
    if ($(element).find("input[type=number]").length) {
      var form = $(element)[0];
      var redemption = $(element).find(".redemption-amount")[0];
      var redemptionError = $(element).find("span.error")[0];
      var redemptionErrorText = $(element).find("span.error .error-text")[0];
      var submitButton = $(element).find(".submit-btn");

      redemption.addEventListener("input", function (event) {
        if (event.target.type == "number") {
          // Each time the user types something, we check if the
          // form fields are valid.
          if (redemption.validity.valid || redemption.validity.rangeUnderflow) {
            redemptionErrorText.innerHTML = ""; // Reset the content of the message
            if (redemption.validity.valid) {
              redemptionError.className = "error";
              if (redemption.value != "") {
                submitButton
                  .addClass("primary-btn")
                  .removeClass("disabled-btn");
              } else {
                submitButton
                  .removeClass("primary-btn")
                  .addClass("disabled-btn");
              }
            } else {
              if (!redemption.validity.rangeUnderflow) {
                redemptionError.className = "error active";
                showRedemptionOptionError(
                  redemption,
                  redemptionErrorText,
                  redemptionError
                );
              } else {
                redemptionError.className = "error";
              }
              submitButton.removeClass("primary-btn").addClass("disabled-btn");
            }
          } else {
            if (!redemption.validity.rangeUnderflow) {
              redemptionError.className = "error active";
              showRedemptionOptionError(
                redemption,
                redemptionErrorText,
                redemptionError
              );
            }
            submitButton.removeClass("primary-btn").addClass("disabled-btn");
          }
        }
      });

      form.addEventListener("submit", function (event) {
        if (!redemption.validity.valid) {
          showRedemptionOptionError(
            redemption,
            redemptionErrorText,
            redemptionError
          );
          event.preventDefault();
        } else {
          showConfirmationPopup();
        }
      });
    }
  });
}

export function showRedemptionOptionError(
  redemption,
  redemptionErrorText,
  redemptionError
) {
  var currencySymbol = redemption.getAttribute("data-currency-symbol");

  // User does not have enough funds
  if (
    redemption.validity.rangeOverflow &&
    parseFloat(redemption.max) <
      parseFloat(redemption.getAttribute("absolute_max"))
  ) {
    redemptionErrorText.textContent = I18n.t(
      "views.dashboards.cash_back_page.error_5"
    );
  } else if (redemption.validity.rangeOverflow) {
    // Amount too high
    redemptionErrorText.textContent = I18n.t(
      "views.dashboards.cash_back_page.error_2"
    );
  } else if (redemption.validity.rangeUnderflow) {
    // Amount too low
    redemptionErrorText.textContent = I18n.t(
      "views.dashboards.cash_back_page.error_3"
    );
  } else if (redemption.validity.stepMismatch) {
    if (redemption.step != "any") {
      redemptionErrorText.textContent = I18n.t(
        "views.dashboards.cash_back_page.error_4",
        { increment_amount: currencySymbol + redemption.step }
      );
    }
  }

  // Set the styling appropriately
  redemptionError.className = "error active";
}

export function cashForwardAgreeListener() {
  $(document).on(
    "click",
    ".cash-forward-redemption-terms-container",
    function () {
      if ($("#cash_forward_redemption_terms_checkbox")[0].checked) {
        $("#cash_forward_submit")
          .removeClass("disabled-btn")
          .addClass("primary-btn");
      } else {
        $("#cash_forward_submit")
          .addClass("disabled-btn")
          .removeClass("primary-btn");
      }
    }
  );
}
